module.exports = __webpack_public_path__ + "img/logo.ecd28123.svg";